import { render } from "./HomeKpis.vue?vue&type=template&id=65b31aec&scoped=true"
import script from "./HomeKpis.vue?vue&type=script&lang=js"
export * from "./HomeKpis.vue?vue&type=script&lang=js"

import "./HomeKpis.vue?vue&type=style&index=0&id=65b31aec&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b31aec"]])

export default __exports__